var _defs, _rect, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSimpleTopList(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 501.06 360.39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #a3a3a3;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 158.46,
    y: 102.61,
    width: 150.49,
    height: 9.96
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 158.46,
    y: 119.83,
    width: 190.23,
    height: 5.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 158.46,
    y: 127.78,
    width: 90.21,
    height: 5.57
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 158.46,
    y: 147.14,
    width: 8.92,
    height: 8.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 169.23,
    y: 148.61,
    width: 42.09,
    height: 5.98
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 212.74,
    y: 148.61,
    width: 101.06,
    height: 5.98
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 158.46,
    y: 159.34,
    width: 8.92,
    height: 8.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 169.23,
    y: 160.81,
    width: 35.25,
    height: 5.98
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 205.94,
    y: 160.81,
    width: 118.96,
    height: 5.98
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 158.46,
    y: 171.54,
    width: 8.92,
    height: 8.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 169.23,
    y: 173,
    width: 40.69,
    height: 5.98
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 211.32,
    y: 173,
    width: 102.48,
    height: 5.98
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 158.46,
    y: 183.74,
    width: 8.92,
    height: 8.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 169.23,
    y: 185.2,
    width: 31.61,
    height: 5.98
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 202.56,
    y: 185.2,
    width: 92.51,
    height: 5.98
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 158.46,
    y: 195.93,
    width: 8.92,
    height: 8.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 169.23,
    y: 197.4,
    width: 39.5,
    height: 5.98
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 210.42,
    y: 197.4,
    width: 132.55,
    height: 5.98
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 158.46,
    y: 208.13,
    width: 8.92,
    height: 8.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 169.23,
    y: 209.6,
    width: 35.25,
    height: 5.98
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 205.94,
    y: 209.6,
    width: 101.06,
    height: 5.98
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 158.46,
    y: 220.33,
    width: 8.92,
    height: 8.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 169.23,
    y: 221.8,
    width: 42.09,
    height: 5.98
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 212.74,
    y: 221.8,
    width: 101.06,
    height: 5.98
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 158.46,
    y: 232.53,
    width: 8.92,
    height: 8.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 169.23,
    y: 233.99,
    width: 29.78,
    height: 5.98
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 200.39,
    y: 233.99,
    width: 83.55,
    height: 5.98
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 158.46,
    y: 244.73,
    width: 8.92,
    height: 8.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 169.23,
    y: 246.19,
    width: 52.24,
    height: 5.98
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 223.11,
    y: 246.19,
    width: 99.72,
    height: 5.98
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 158.46,
    y: 256.92,
    width: 8.92,
    height: 8.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 169.23,
    y: 258.39,
    width: 32.38,
    height: 5.98
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 203.11,
    y: 258.39,
    width: 103.89,
    height: 5.98
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimpleTopList);
export default __webpack_public_path__ + "static/media/simple_top_list.8c380102210121192497413f6de84739.svg";
export { ForwardRef as ReactComponent };